export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white rounded-t-[40px]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-5">
            <h3 className="text-5xl font-light text-white mb-4">Stay Connected</h3>
            <p className="text-lg text-gray-400 mb-6">
              Join our VIP list for exclusive events and special offers
            </p>
            <form className="flex gap-3">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 bg-transparent border-b-2 border-gray-600 px-2 py-3 text-white placeholder-gray-500 focus:border-pink-500 focus:outline-none transition-colors"
              />
              <button
                type="submit"
                className="bg-pink-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-pink-700 transition-all hover:scale-105 whitespace-nowrap"
              >
                Subscribe →
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-white mb-6 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-pink-400 transition-colors underline cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-400 hover:text-pink-400 transition-colors underline cursor-pointer"
                >
                  Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('live-karaoke')}
                  className="text-gray-400 hover:text-pink-400 transition-colors underline cursor-pointer"
                >
                  Live Karaoke
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-pink-400 transition-colors underline cursor-pointer"
                >
                  Book Now
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-white mb-6 uppercase tracking-wider">Gang Nam Style Karaoke</h4>
            <address className="not-italic text-gray-400 space-y-2 mb-6">
              <p>2645 N Berkeley Lake Rd NW</p>
              <p>STE 228, Duluth, GA 30096</p>
              <a href="tel:+14702683498" className="block hover:text-pink-400 transition-colors cursor-pointer">
                (470) 268-3498
              </a>
            </address>
            <div>
              <p className="text-sm text-gray-500 mb-3">Follow Us</p>
              <div className="flex gap-3">
                <a
                  href="https://www.instagram.com/gangnamstylekaraokeatl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-all cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61587411106221"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-all cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@kangnamstylekaraoke"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-all cursor-pointer"
                >
                  <i className="ri-tiktok-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex gap-6">
              <a
                href="https://www.instagram.com/gangnamstylekaraokeatl/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61587411106221"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer"
              >
                Facebook
              </a>
              <a
                href="https://www.tiktok.com/@kangnamstylekaraoke"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer"
              >
                TikTok
              </a>
            </div>
            <p className="text-gray-500 text-sm">© 2026 Gang Nam Style Karaoke. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer">
                Terms
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-400 hover:text-pink-400 transition-colors underline text-sm cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}